import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  RESPONSIVE_DRAWER,
  responsiveDrawerMedia,
  rightDrawerWidth,
  shouldForwardProp,
} from "../common/Common.style";

type StyleBoxProps = {
  open?: boolean;
};

export const AppShell = styled(Box)({
  display: "flex",
  height: "100dvh",
});

export const Main = styled("main", {
  shouldForwardProp: prop => shouldForwardProp<StyleBoxProps>(["open"], prop),
})<StyleBoxProps>(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [responsiveDrawerMedia.wide]: {
      marginRight: rightDrawerWidth,
    },
    [responsiveDrawerMedia.narrow]: {
      marginRight: `${RESPONSIVE_DRAWER.NARROW_PX}px`,
    },
  }),
}));
